var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheckboxSelected = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "-2 -2 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Customers-/-Table-Row-/-Selected",
    transform: "translate(-15.000000, -18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Label-Paid-Copy",
    transform: "translate(15.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "currentColor",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2-Copy-3",
    fill: "#FFFFFF",
    points: "8.853706 12.726521 5.360924 9.124402 4 10.528315 9.304139 16 16 3.458116 14.313763 2.5"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheckboxSelected, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CheckboxSelected.7e9c857d.svg";
export { ForwardRef as ReactComponent };